import { Navigate, type RouteObject, useLocation } from 'react-router-dom';

const LEGACY_WEB_ADMIN_PREFIX = '/web-admin/app';
const CANONICAL_WEB_ADMIN_PREFIX = '/webadmin/app';

function LegacyWebAdminRedirect() {
  const location = useLocation();
  const suffix = location.pathname.startsWith(LEGACY_WEB_ADMIN_PREFIX)
    ? location.pathname.slice(LEGACY_WEB_ADMIN_PREFIX.length)
    : '';
  const targetPath = `${CANONICAL_WEB_ADMIN_PREFIX}${suffix || ''}`;
  return <Navigate to={`${targetPath}${location.search}${location.hash}`} replace />;
}

function LegacyStockB2BRedirect() {
  const location = useLocation();
  return <Navigate to={`${CANONICAL_WEB_ADMIN_PREFIX}/stock/b2b-sales${location.search}${location.hash}`} replace />;
}

function SettingsB2BCustomersRedirect() {
  const location = useLocation();
  return <Navigate to={`${CANONICAL_WEB_ADMIN_PREFIX}/references?tab=b2b-customers${location.hash}`} replace />;
}

function SettingsProductMappingsRedirect() {
  const location = useLocation();
  return <Navigate to={`${CANONICAL_WEB_ADMIN_PREFIX}/references?tab=product-mappings${location.hash}`} replace />;
}

function StockSettingsRedirect() {
  const location = useLocation();
  return <Navigate to={`${CANONICAL_WEB_ADMIN_PREFIX}/stock/products${location.search}${location.hash}`} replace />;
}

function UsersRedirect() {
  const location = useLocation();
  return <Navigate to={`${CANONICAL_WEB_ADMIN_PREFIX}/settings/users${location.search}${location.hash}`} replace />;
}

export const rootCompatRoutes: RouteObject[] = [
  {
    path: '/web-admin/app/*',
    element: <LegacyWebAdminRedirect />,
  },
];

export const appCompatRoutes: RouteObject[] = [
  {
    path: 'stock/b2b',
    element: <LegacyStockB2BRedirect />,
  },
  {
    path: 'settings/b2b-customers',
    element: <SettingsB2BCustomersRedirect />,
  },
  {
    path: 'settings/product-mappings',
    element: <SettingsProductMappingsRedirect />,
  },
  {
    path: 'stock/settings',
    element: <StockSettingsRedirect />,
  },
  {
    path: 'users',
    element: <UsersRedirect />,
  },
];
